import { render, staticRenderFns } from "./click-comment.vue?vue&type=template&id=35657da7"
import script from "./click-comment.vue?vue&type=script&lang=js"
export * from "./click-comment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports